import { Injectable } from '@angular/core';
import { NotificationBaseApi } from './notification-base-api';

@Injectable({providedIn: 'root'})
export class NotificationApi extends NotificationBaseApi {
  protected apiUrl = '/api/v1';
}
